/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Enrollment
 */
export interface Enrollment {
    /**
     * 
     * @type {string}
     * @memberof Enrollment
     */
    classId: string;
    /**
     * 
     * @type {string}
     * @memberof Enrollment
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof Enrollment
     */
    role: string;
}

/**
 * Check if a given object implements the Enrollment interface.
 */
export function instanceOfEnrollment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "classId" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "role" in value;

    return isInstance;
}

export function EnrollmentFromJSON(json: any): Enrollment {
    return EnrollmentFromJSONTyped(json, false);
}

export function EnrollmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Enrollment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classId': json['classId'],
        'userId': json['userId'],
        'role': json['role'],
    };
}

export function EnrollmentToJSON(value?: Enrollment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classId': value.classId,
        'userId': value.userId,
        'role': value.role,
    };
}

